<template>
  <div class="paragraph" :id="id || 'changeme'">
    <h2 v-if="headline" class="headline">
      {{ headline }}
    </h2>

    <p class="text">
      <slot></slot>
    </p>
  </div>
</template>

<script>

export default {
  name: 'app-paragraph',
  props: ['id', 'headline']
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

.paragraph {
  padding-top: 1rem;
  padding-bottom: 1rem;

  .headline {
    font-size: 1.7rem;
    line-height: 2rem;
    padding-left: 1.8rem;
    font-weight: bold;
    font-family: $headline-font;
    position: relative;

    &::before {
      position: absolute;
      content: '';
      left:-3%;
      top: 0;

      background-image: url('../assets/key.svg');
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Paragraph.vue